<template>
  <vs-tabs position="left" class="tabs-shadow-none">
    <vs-tab icon-pack="feather" icon="icon-code" label="Forms">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <dynamic-forms-list />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-home" label="Venue overview">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <venue-overview />
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import DynamicFormsList from "./DynamicFormsList.vue";
import VenueOverview from "./VenueOverview/VenueOverview.vue";

import { mapGetters } from "vuex";

export default {
  components: {
    DynamicFormsList,
    VenueOverview,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({}),
  },
};
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>